const copyText = (text) => {
  const cleanText = text.trim();

  if (!cleanText) return Promise.reject();

  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(cleanText);
  }

  const textarea = document.createElement('textarea');
  textarea.value = cleanText;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();

  const copied = document.execCommand('copy');
  textarea.remove();

  return copied ? Promise.resolve() : Promise.reject();
};

const getCopyTextTrigger = (target) => (
  target instanceof Element
    ? target.closest('[data-copy-text]')
    : null
);

const showCopiedState = (el, success) => {
  const originalLabel = el.getAttribute('aria-label');
  const copyValueEl = el.querySelector('.main-product-specs__copy-value');

  el.dataset.copied = success ? 'true' : 'false';
  el.setAttribute('aria-label', success ? 'Copied' : 'Copy failed');
  if (copyValueEl) {
    copyValueEl.dataset.copyState = success ? 'success' : 'error';
  }

  setTimeout(() => {
    delete el.dataset.copied;
    if (copyValueEl) {
      delete copyValueEl.dataset.copyState;
    }

    if (originalLabel) {
      el.setAttribute('aria-label', originalLabel);
    } else {
      el.removeAttribute('aria-label');
    }
  }, 1500);
};

const onCopyTextTrigger = (event) => {
  const trigger = getCopyTextTrigger(event.target);

  if (!trigger) return;

  copyText(trigger.dataset.copyValue || trigger.textContent).then(
    () => showCopiedState(trigger, true),
    () => showCopiedState(trigger, false),
  );
};

const onCopyTextTriggerKeydown = (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const trigger = getCopyTextTrigger(event.target);

  if (!trigger) return;

  event.preventDefault();
  trigger.click();
};

document.addEventListener('click', onCopyTextTrigger);
document.addEventListener('keydown', onCopyTextTriggerKeydown);

const getTargetCopyText = (targetEl) => {
  const copyTextEls = Array.from(targetEl.querySelectorAll('[data-copy-text]'));

  if (!copyTextEls.length) return targetEl.textContent;

  return copyTextEls.map((el) => {
    const title = el.previousElementSibling?.textContent?.trim();
    const value = el.dataset.copyValue || el.textContent;

    return [title, value.trim()].filter(Boolean).join('\n');
  }).join('\n\n');
};

class CopyButton extends HTMLElement {
  #targetEl;
  #origTextContent

  constructor() {
    super();
  }

  connectedCallback() {
    this.#origTextContent = this.textContent;
    this.addEventListener('click', this.#onCopy);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onCopy);
  }

  static get observedAttributes() {
    return ['data-target-selector'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-target-selector' && newValue) {
      this.#targetEl = document.querySelector(newValue);
    }
  }

  #onCopy() {
    if (this.#targetEl) {
      copyText(getTargetCopyText(this.#targetEl)).then(
        () => {
          /* success */
          this.style.minWidth = this.clientWidth + 'px';
          this.textContent = 'Copied';
          setTimeout(() => {
            this.style.minWidth = null;
            this.textContent = this.#origTextContent;
          }, 1500);
        },
        () => {
          /* clipboard write failed */
          this.style.minWidth = this.clientWidth + 'px';
          this.textContent = 'Copy Failed!';
          setTimeout(() => {
            this.style.minWidth = null;
            this.textContent = this.#origTextContent;
          }, 1500);
        },
      );
    }

  }

  
}

customElements.define('copy-button', CopyButton);
